import React from "react";

import {
  Grid,
  IconButton,
  Typography,
} from "@braintrust/braintrust-ui-components";
import {
  ArrowLeftIcon,
  ArrowRightIcon,
  CloseIcon,
} from "@braintrust/braintrust-ui-components/Icons";

type BidListHeaderProps = {
  closeDrawer: () => void;
  totalBids: number;
  goToNextBid: () => void;
  goToPreviousBid: () => void;
  currentBidIndex: number | undefined;
};

export const HEADER_HEIGHT = 82;

export const BidDetailsHeader = ({
  goToNextBid,
  goToPreviousBid,
  currentBidIndex,
  closeDrawer,
  totalBids,
}: BidListHeaderProps) => {
  return (
    <Grid
      size={{
        xs: 12,
      }}
      container
      sx={{
        justifyContent: "space-between",
        alignItems: "center",
        height: HEADER_HEIGHT,
        p: 2,
      }}
    >
      <Grid
        container
        spacing={2}
        size={{
          xs: "auto",
        }}
        sx={{ alignItems: "center" }}
      >
        <Grid>
          <IconButton
            onClick={goToPreviousBid}
            size="medium"
            variant="primary"
            aria-label="Previous"
          >
            <ArrowLeftIcon />
          </IconButton>
        </Grid>

        <Grid>
          <IconButton
            onClick={goToNextBid}
            size="medium"
            variant="primary"
            aria-label="Next"
          >
            <ArrowRightIcon />
          </IconButton>
        </Grid>

        {typeof currentBidIndex !== "undefined" && (
          <Grid>
            <Typography
              component="p"
              variant="paragraph"
              size="small"
              style={{ color: "var(--grey-2)" }}
            >
              Application {currentBidIndex + 1} of {totalBids}
            </Typography>
          </Grid>
        )}
      </Grid>

      <Grid>
        <IconButton
          size="small"
          variant="transparent"
          onClick={closeDrawer}
          aria-label="Close"
        >
          <CloseIcon />
        </IconButton>
      </Grid>
    </Grid>
  );
};
